import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getType } from 'deox';
import {
  applyTemplate,
  getTemplateList,
  importTemplateAction,
  setCurrentTemplateId,
  updateTemplateList
} from 'modules/template';
import { deleteAllScenes, setCurrentScene } from 'modules/scenes';
import { isNil } from 'ramda';
import { Template, TemplateListItem } from 'types/templateTypes';
import { addAlert } from 'modules/alert';
import { loadTemplateData, loadTemplatesList } from 'utils/apiWrapper';
import { loadEffectsFont, setEffectTextSize } from './effectsSaga';
import { initScenesLoader } from 'modules/scenesLoader';
import { Licenses } from 'types/Licenses';
import { getUrlParametr } from 'utils/utils';
import { templateMessages } from 'constants/errorMessages';
import { saveRevision } from 'modules/revisions';
import { ToolName } from 'types/AppState';
import { saveProjectFile } from 'modules/projectFles';
import { getPlayer } from 'utils/PlayerContext';
import ErrorLogger from '../../components/ErrorLogger';

export function* importTemplateSaga({ payload: id }: ReturnType<typeof importTemplateAction>) {
  yield put(deleteAllScenes());
  try {
    const templatesList: TemplateListItem[] = yield select(getTemplateList);
    const template = templatesList.find(item => item.id === id);
    const templateData: Template = yield call(loadTemplateData, template.url);
    for (const key in templateData.effects) {
      if (templateData.effects[key] !== undefined) {
        yield call(loadEffectsFont, templateData.effects[key]);
        templateData.effects[key] = yield call(setEffectTextSize, templateData.effects[key]);
      }
    }

    if (template.is_paid) {
      templateData.scenes.items.forEach(scene => {
        scene.license = Licenses.TemplatePremium;
        scene.templateId = id;
      });
    }

    yield put(applyTemplate(templateData));
    yield put(setCurrentTemplateId(id));
    getPlayer().setTime(0);
    yield put(setCurrentScene(templateData.scenes.items[0].id));

    if (!window.analytics) {
      window.analytics = {};
    }
    window.analytics.templateId = id;

    yield put(initScenesLoader());
    yield put(saveRevision(ToolName.Template));
    yield put(saveProjectFile());
  } catch (error) {
    ErrorLogger.trigger(error);
    yield put(addAlert(templateMessages.title, templateMessages.loadingError));
  }
}

function* templatesFetched({ payload: templatesList }: ReturnType<typeof updateTemplateList>) {
  if (isNil(templatesList)) return;

  const templateId = getUrlParametr('templateId');

  if (templateId) {
    yield put(importTemplateAction(templateId));
  }
}

export function* loadTemplates() {
  const templatesList: TemplateListItem[] = yield call(loadTemplatesList);
  yield put(updateTemplateList(templatesList));
}

export default function* templatesSaga() {
  yield takeEvery(getType(importTemplateAction), importTemplateSaga);
  yield takeEvery(getType(updateTemplateList), templatesFetched);
}
